import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/axios';

export const fetchNotifications = createAsyncThunk(
  'notifications/fetch',
  async (unreadOnly = false, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/notifications', { params: { unreadOnly: unreadOnly ? 'true' : undefined } });
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur.');
    }
  }
);

export const markNotificationRead = createAsyncThunk(
  'notifications/markRead',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.patch(`/notifications/${id}/read`);
      return data.notification;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur.');
    }
  }
);

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    list: [],
    unreadCount: 0,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.list = action.payload.notifications || [];
        state.unreadCount = action.payload.unreadCount ?? 0;
        state.loading = false;
      })
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(markNotificationRead.fulfilled, (state, action) => {
        const n = state.list.find((x) => x._id === action.payload._id);
        if (n) {
          n.read = true;
          n.readAt = action.payload.readAt;
        }
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      });
  },
});

export default notificationsSlice.reducer;
